export default {
  getAlertRules: {
    server: '/projects/{projectId}/alert-rules',
    method: 'get',
  },
  createAlertRule: {
    server: '/projects/{projectId}/alert-rules',
    method: 'post',
  },
  updateAlertRule: {
    server: '/projects/{projectId}/alert-rules/{alertRuleId}',
    method: 'patch',
  },
  deleteAlertRule: {
    server: '/projects/{projectId}/alert-rules/{alertRuleId}',
    method: 'delete',
  },
};
